"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
exports.Text = styled_components_1.default.div `
  font-family: ${props => props.theme.fonts.default};
  color: ${props => props.theme.colors.color};
`;
//# sourceMappingURL=text.js.map